export default __webpack_public_path__ + "static/media/yandex.8a8e9038.svg";